import evolutionsReducer from "./evolutions/evolutionsSlice";
import globalStateReducer from "./globalState/globalStateSlice";
import loadedContentReducer from "./loadedContent/loadedContentSlice";
import messageReducer from "./message/messageSlice";
import myClubReducer from "./myClub/myClubSlice";
import myPlayersReducer from "./myClub/myPlayersSlice";
import newsReducer from "./news/newsSlice";
import playersReducer from "./players/playersSlice";
import sbcFiltersReducer from "./sbcs/sbcFiltersSlice";
import sbcsSetsReducer from "./sbcs/sbcSetsSlice";
import sbcsReducer from "./sbcs/sbcsSlice";
import defaultSquadBuilderReducer from "./squadBuilder/defaultSquadBuilder/defaultSquadBuilderSlice";
import tacticsReducer from "./tactics/tacticsSlice";
import userReducer from "./user/userSlice";

const reducer = {
  userReducer,
  sbcsSetsReducer,
  sbcFiltersReducer,
  messageReducer,
  loadedContentReducer,
  sbcsReducer,
  playersReducer,
  evolutionsReducer,
  defaultSquadBuilderReducer,
  tacticsReducer,
  newsReducer,
  globalStateReducer,
  myClubReducer,
  myPlayersReducer,
};

export default reducer;
